<script>
    export let togglePane;
    export let exportToExcel;
    export let exportToPDF;
    export let isMenuOpen;
    export let toggleMenu;
    export let canCreate;
  </script>
  
  <div class="relative flex items-center">
    <!-- Botón para el menú en móviles -->
    <button on:click={toggleMenu} class="text-white focus:outline-none md:hidden">
      <i class="fas fa-bars"></i>
    </button>
  
    <!-- Menú desplegable (visible solo en móviles) -->
    <div class={`absolute top-full mt-1 bg-white rounded shadow-lg p-2 z-50 ${isMenuOpen ? 'block' : 'hidden'} md:hidden`} style="left: 18px;">
      {#if canCreate}
        <button 
          on:click={togglePane} 
          class="block w-full text-left px-2 py-1 border border-black bg-white text-black rounded hover:border-green-500 hover:bg-blue-700 transition duration-200 text-sm">
          <i class="fas fa-plus mr-1"></i>
        </button>
      {/if}
      <button 
        on:click={exportToExcel} 
        class="block w-full text-left px-2 py-1 border border-black bg-white text-black rounded hover:border-green-500 hover:bg-blue-700 transition duration-200 text-sm">
        <i class="fas fa-file-excel mr-1"></i>
      </button>
      <button 
        on:click={exportToPDF} 
        class="block w-full text-left px-2 py-1 border border-black bg-white text-black rounded hover:border-green-500 hover:bg-blue-700 transition duration-200 text-sm">
        <i class="fas fa-file-pdf mr-1"></i>
      </button>
    </div>
  
    <!-- Botones y búsqueda visibles en escritorio -->
    <div class="hidden md:flex items-center ml-auto">
      {#if canCreate}
        <button 
          on:click={togglePane} 
          class="px-4 py-2 border border-white text-white rounded hover:border-green-500 hover:bg-blue-700 transition duration-200">
          <i class="fas fa-plus mr-2"></i> Crear
        </button>
      {/if}
      &nbsp;
      <button 
        on:click={exportToExcel} 
        class="px-4 py-2 border border-white text-white rounded hover:border-green-500 hover:bg-blue-700 transition duration-200">
        <i class="fas fa-file-excel mr-2"></i> Exportar a Excel
      </button>
      &nbsp;
      <button 
        on:click={exportToPDF} 
        class="px-4 py-2 border border-white text-white rounded hover:border-green-500 hover:bg-blue-700 transition duration-200">
        <i class="fas fa-file-pdf mr-2"></i> Exportar a PDF
      </button>
      &nbsp;
    </div>
  </div>
  